import { Box, Button, Card, Stack, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { MarkEmailUnreadOutlined } from "@mui/icons-material";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";
import DocumentTitle from "../components/DocumentTitle";

export default function VerifyEmail() {
  const { t } = useTranslation("common");
  const theme = useTheme();
  const { loginWithRedirect, logout } = useAuth0();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <DocumentTitle title={t("common.verify_email")} />
      <Card
        sx={{
          maxWidth: 440,
          width: "100%",
          p: 4,
          borderRadius: "12px",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.main,
            borderRadius: "10px",
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <MarkEmailUnreadOutlined />
        </Box>
        <Typography variant="h5" fontWeight={600} sx={{ mb: 1 }}>
          {t("common.verify_email")}
        </Typography>
        <Typography color="textSecondary" sx={{ mb: 3, lineHeight: 1.6 }}>
          {t("common.verify_email_message")}
        </Typography>
        <Stack direction="row" spacing={1.5} justifyContent="center">
          <Button
            variant="contained"
            onClick={() =>
              loginWithRedirect({
                // no search: after an Action denial it holds stale error/state params
                appState: { returnTo: window.location.pathname },
              })
            }
            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600 }}
          >
            {t("common.verify_email_signin")}
          </Button>
          <Button
            onClick={() =>
              logout({ logoutParams: { returnTo: window.location.origin } })
            }
            sx={{ borderRadius: "8px", textTransform: "none" }}
          >
            {t("common.verify_email_logout")}
          </Button>
        </Stack>
      </Card>
    </Box>
  );
}
